export const breakpoints = {
    xs: '0px',
    sm: '600px',
    md: '960px',
    lg: '1280px',
    xl: '1920px',
};
export const containerWidth = {
    lg: '1600px',
    md: '1400px',
    sm: '1150px',
};
